import React from 'react';  
import './index.css';
import AttachList from 'component/attachList'
import NoContent from 'component/noContent' 
 
class ReportAttach extends React.Component{
  render(){
    const {attachmentList}= this.props;
    return (
      <div  className="report-item">
        <p className="report-title">实验附件</p>
        {
          attachmentList&&attachmentList.size!=0?
          attachmentList.map((item,index)=>{
            return(<AttachList key={index} data={item}/>)
          }):
          <NoContent/>
        }
      </div>
      )
  }
}
export default ReportAttach;

 

 
 